import script from "./AidaInterviewStep.vue?vue&type=script&setup=true&lang=js"
export * from "./AidaInterviewStep.vue?vue&type=script&setup=true&lang=js"

import "./AidaInterviewStep.vue?vue&type=style&index=0&id=3555dc42&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3555dc42"]])

export default __exports__